import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { Relay42Service } from '@mnz-core/services/relay42.service';
import { TruncatePipe } from '@mnz-shared/pipes/truncate.pipe';
import { Relay42Category } from '@mnz-core/models/_enums';

@Directive({
  selector: '[relay42]'
})
export class Relay42Directive {
  constructor(private readonly _relay42Service: Relay42Service, private readonly _elementRef: ElementRef) {}

  @Input()
  relay42: { prefix: string; label: string } = { prefix: null, label: null };

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    if (event.detail < 1 && document['documentMode'] == null) {
      return;
    }

    const {
      localName: type = 'button',
      innerText: elementLabel = 'no_label'
    }: {
      localName: string;
      innerText: string;
    } = this._elementRef.nativeElement;

    const { prefix = null, label = null } = this.relay42;

    const suffix = this._truncateLabel(label || elementLabel);

    const name = `${prefix ? `${prefix.toLowerCase()} / ` : ''}${suffix ? suffix : 'no_label'}`;

    this._relay42Service.publishEvent(Relay42Category.BUTTON_CLICK, null, { name, type });
  }

  private _truncateLabel(value: string): string {
    return new TruncatePipe().transform(value ? value.trim().toLowerCase() : value, 50);
  }
}
